/* `service.ais-integration-th` (Ruben's). The call is same-origin by default: nginx proxies
   /api/ais/ to the service in-cluster (see nginx/nginx.conf). That service is HTTP only by
   design, so a direct browser call from this HTTPS page would be blocked as mixed content.

   Set VUE_APP_AIS_API_HOST to an absolute origin to bypass the proxy — the dev server proxies
   the same path (vue.config.js), so local development needs no override either. */
export const aisConfig = {
    host: process.env.VUE_APP_AIS_API_HOST || '',
    wapLinkPath: process.env.VUE_APP_AIS_WAP_LINK_PATH || '/api/ais/wap/link',
};
